import { render } from "./collectInvoiceXx.vue?vue&type=template&id=61372206&scoped=true"
import script from "./collectInvoiceXx.vue?vue&type=script&lang=js"
export * from "./collectInvoiceXx.vue?vue&type=script&lang=js"

import "./collectInvoiceXx.vue?vue&type=style&index=0&id=61372206&lang=less&scoped=true"
import "./collectInvoiceXx.vue?vue&type=style&index=1&id=61372206&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61372206"]])

export default __exports__